<div class="notif-panel">
    <vb-panel-header
        title="Notifications &amp; reminders"
        subtitle="Choose how you'd like to hear from us.">
        <div panelActions>
            <vb-button
                variant="primary"
                [disabled]="!isDirty || isLoading"
                (clicked)="updateNotificationPreferences()">
                Save changes
            </vb-button>
        </div>
    </vb-panel-header>

    <vb-banner *ngIf="smsOptedOut" tone="warn" class="notif-banner">
        <strong>Your phone number has opted out of Viewbid texts.</strong> To
        receive them again, reply START to any text from Viewbid.
    </vb-banner>

    <!-- The design's vb-segmented ("Notification preferences" / "Reminders")
         is deliberately omitted: the preferences API returns no reminder-type
         entries, so the second segment would be a dead tab. Reinstate it when
         reminder data ships (see the component-class doc comment). -->

    <ng-container *ngIf="!isLoading">
        <section
            *ngIf="userPreferences.length > 1"
            class="notif-card"
            aria-label="Notification preferences">
            <vb-pref-row
                [label]="userPreferences[0].title"
                [description]="userPreferences[0].description"
                [showChannels]="false"
                [enabled]="userPreferences[0].all"
                (enabledChange)="
                    onAllSwitchChange('user', $event, 0)
                "></vb-pref-row>
            <vb-pref-row
                *ngFor="let pref of userPreferences | slice: 1; let i = index"
                [label]="pref.title"
                [description]="pref.description"
                [email]="!!pref.channels?.email"
                [text]="!smsOptedOut && !!pref.channels?.SMS"
                [textDisabled]="smsOptedOut"
                [enabled]="isTypeOn(pref)"
                (emailChange)="
                    onChannelSwitchChange('user', $event, i + 1, 'email')
                "
                (textChange)="
                    onChannelSwitchChange('user', $event, i + 1, 'SMS')
                "
                (enabledChange)="
                    onAllSwitchChange('user', $event, i + 1)
                "></vb-pref-row>
        </section>

        <div *ngIf="adminPreferences.length > 1" class="notif-group">
            <h3 class="notif-eyebrow">Admin notification preferences</h3>
            <section class="notif-card" aria-label="Admin notification preferences">
                <vb-pref-row
                    [label]="adminPreferences[0].title"
                    [description]="adminPreferences[0].description"
                    [showChannels]="false"
                    [enabled]="adminPreferences[0].all"
                    (enabledChange)="
                        onAllSwitchChange('admin', $event, 0)
                    "></vb-pref-row>
                <vb-pref-row
                    *ngFor="
                        let pref of adminPreferences | slice: 1;
                        let i = index
                    "
                    [label]="pref.title"
                    [description]="pref.description"
                    [email]="!!pref.channels?.email"
                    [text]="!smsOptedOut && !!pref.channels?.SMS"
                [textDisabled]="smsOptedOut"
                    [enabled]="isTypeOn(pref)"
                    (emailChange)="
                        onChannelSwitchChange('admin', $event, i + 1, 'email')
                    "
                    (textChange)="
                        onChannelSwitchChange('admin', $event, i + 1, 'SMS')
                    "
                    (enabledChange)="
                        onAllSwitchChange('admin', $event, i + 1)
                    "></vb-pref-row>
            </section>
        </div>

        <p
            *ngIf="notificationPreferences && notificationPreferences.length === 0"
            class="notif-empty">
            No data to show at the moment.
        </p>
    </ng-container>

    <div *ngIf="isLoading" class="vb-spinner-box vb-spinner-box--panel">
        <vb-spinner size="xl" label="Loading preferences"></vb-spinner>
    </div>
</div>
